import styled from "styled-components";

export const SpaceWrapper = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: ${(props) => props.backgroundColor};;
`;
